<header class="bciti-dialog__header">
    <div class="bciti-dialog__title">
        {{ 'pages.user-cards.add-family-member-selection-dialog.title' | translate }}
    </div>
    <button class="bciti-dialog__close-button" (click)="closeDialog()">
        <span  class="icon icon-close"></span>
    </button>
</header>
<div class="bciti-dialog__content">
    <ul class="options">
        <li class="option" *ngFor="let option of options">
            <button class="choice-button" type="button" (click)="onOptionClick(option)">
                <div class="choice-button__inner">
                    <div class="choice-button__header">
                        <span *ngIf="option.icon" class="choice-button__icon icon" [ngClass]="option.icon"></span>
                        <div class="choice-button__title">{{ option.title }}</div>
                    </div>
                    <div class="choice-button__body" [innerHTML]="option.body"></div>
                </div>
                <div class="choice-button__arrow">
                    <span class="icon icon-arrow-right"></span>
                </div>
            </button>
        </li>
    </ul>
</div>